import getDefaultState from './state';

export function flush(state) {
  Object.assign(state, getDefaultState());
}

export function updateCurrentProduct(state, { product }) {
  // Sort assets
  if (product?.assets?.length > 1) {
    product.assets.sort((a, b) => {
      let aDesc = null;
      let bDesc = null;

      try {
        aDesc = JSON.parse(a.description);
      }
      catch (e) {
        return -1;
      }

      try {
        bDesc = JSON.parse(b.description);
      }
      catch (e) {
        return -1;
      }

      if (!aDesc?.order) {
        return -1;
      }
      if (!bDesc?.order) {
        return 1;
      }

      if (aDesc.order < bDesc.order) {
        return -1;
      }
      if (aDesc.order > bDesc.order) {
        return 1;
      }

      return 0;
    });
  }

  state.current = product;
}

export function updateProducts(state, { products }) {
  state.all = products;
}

export function updateExtrasFilter(state, { filter }) {
  state.extrasFilter = filter;
}

export function updateNewCarsFilter(state, { filter }) {
  state.newCarsFilter = filter;
}

export function updateMeta(state, { meta }) {
  state.meta = meta;
}

export function updateSort(state, { sort }) {
  state.sort = sort;
}
